var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("material.fiveBitCode"),
                                        prop: "fiveBitCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.fiveBitCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "fiveBitCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.fiveBitCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "iconStyle",
                                      attrs: {
                                        label: _vm.$t("material.eightBitCode"),
                                        prop: "eightBitCodeStr",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          type: "textarea",
                                          autosize: { maxRows: 1 },
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.eightBitCodeStr,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "eightBitCodeStr",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.eightBitCodeStr",
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-menu",
                                        on: { click: _vm.menuClick },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "material.eightBitCodeName"
                                        ),
                                        prop: "eightBitCodeName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.queryCondition.eightBitCodeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "eightBitCodeName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.eightBitCodeName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "工厂名称",
                                        prop: "tmPlantName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.tmPlantName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "tmPlantName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.tmPlantName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "工厂编码",
                                                prop: "tmPlantCode",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .tmPlantCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "tmPlantCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.tmPlantCode",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "结算单位名称",
                                                prop: "settlementUnitName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .settlementUnitName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "settlementUnitName",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.settlementUnitName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Category1",
                                                prop: "categoryLevel1Id",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.changeCategory1()
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .categoryLevel1Id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "categoryLevel1Id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.categoryLevel1Id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.categoryList1,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.name,
                                                        value:
                                                          item.tmCategoryId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Category2",
                                                prop: "categoryLevel2Id",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.changeCategory2()
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .categoryLevel2Id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "categoryLevel2Id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.categoryLevel2Id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.categoryList2,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.name,
                                                        value:
                                                          item.tmCategoryId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Category3",
                                                prop: "categoryLevel3Id",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .categoryLevel3Id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "categoryLevel3Id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.categoryLevel3Id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.categoryList3,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.name,
                                                        value:
                                                          item.tmCategoryId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("material.status"),
                                                prop: "status",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.status",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.statusList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "创建日期(从)",
                                                prop: "startCreateDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  "picker-options":
                                                    _vm.pickerOptionsStart,
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .startCreateDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "startCreateDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.startCreateDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "创建日期(至)",
                                                prop: "endCreateDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  "picker-options":
                                                    _vm.pickerOptionsEnd,
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .endCreateDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "endCreateDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.endCreateDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "状态",
                                                prop: "conductStatus",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .conductStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "conductStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.conductStatus",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.conductStatusList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.emplFlag != "SUP"
                                        ? _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "material.isConventionalMaterial"
                                                    ),
                                                    prop: "isUrgentMaterial",
                                                  },
                                                },
                                                [
                                                  _c("ic-select", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table:
                                                        "TM_MATERIAL_RECORD",
                                                      field: "IS_NOT",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryCondition
                                                          .isUrgentMaterial,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryCondition,
                                                          "isUrgentMaterial",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryCondition.isUrgentMaterial",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.restQueryForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _vm.emplFlag == "S" || _vm.emplFlag == "M"
                ? _c(
                    "el-dropdown",
                    {
                      attrs: {
                        "split-button": "",
                        type: "primary",
                        placement: "bottom",
                      },
                      on: { click: _vm.handleClick },
                    },
                    [
                      _vm._v(" 新增 "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            [
                              _vm.emplFlag == "S" || _vm.emplFlag == "M"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goAdd("add")
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("material.add")))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            [
                              _vm.emplFlag == "M"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goAdd(
                                            "add",
                                            "",
                                            "new_toy_material"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("material.primary"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            [
                              _vm.emplFlag == "M"
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "acl",
                                          rawName: "v-acl",
                                          value:
                                            _vm.addition_of_unconventional_materials,
                                          expression:
                                            "addition_of_unconventional_materials",
                                        },
                                      ],
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goAdd(
                                            "conven",
                                            "",
                                            "new_unconventional_materials"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "material.new_unconventional_materials"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            [
                              _vm.emplFlag == "M"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goAdd(
                                            "add",
                                            "",
                                            "new_conventional_material"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "material.new_conventional_material"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.material_delete,
                      expression: "material_delete",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.deleteRow },
                },
                [_vm._v(_vm._s(_vm.$t("common.del")))]
              ),
              _vm.isRecall
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onWithdraw },
                    },
                    [_vm._v("撤回")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.material_information_copy,
                      expression: "material_information_copy",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.copy },
                },
                [_vm._v(_vm._s(_vm.$t("material.material_information_copy")))]
              ),
              _vm.emplFlag == "S" || _vm.emplFlag == "M"
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.downLoadTemplate },
                    },
                    [_vm._v("模板下载")]
                  )
                : _vm._e(),
              _vm.emplFlag == "S" || _vm.emplFlag == "M"
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: {
                        "margin-right": "10px",
                        "vertical-align": "middle",
                        "line-height": "0",
                      },
                      attrs: {
                        "show-file-list": false,
                        "before-upload": _vm.beforeUpload,
                        headers: _vm.uploadHeader,
                        action: _vm.fileUploadUrl,
                        "on-success": _vm.uploadSuccess,
                        "on-error": _vm.uploadError,
                        multiple: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { height: "100%" },
                          attrs: { type: "primary", size: "mini" },
                        },
                        [_vm._v("批量导入")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isBatch
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onBatchEdit },
                    },
                    [_vm._v("批量修改")]
                  )
                : _vm._e(),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value:
                        (_vm.material_data_synchronization_MDM,
                        _vm.material_data_decentralization_MDM),
                      expression:
                        "material_data_synchronization_MDM,material_data_decentralization_MDM",
                    },
                  ],
                  attrs: {
                    "split-button": "",
                    type: "primary",
                    placement: "bottom",
                  },
                  on: { click: _vm.handleClick },
                },
                [
                  _vm._v(" 接口同步 "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_data_synchronization_MDM,
                                  expression:
                                    "material_data_synchronization_MDM",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.dataSyncMDM("formal")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("material.DataSyncMDM"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_data_synchronization_MDM,
                                  expression:
                                    "material_data_synchronization_MDM",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.senfRpAndRpf("formal")
                                },
                              },
                            },
                            [_vm._v("发送RP&RPF")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_data_decentralization_MDM,
                                  expression:
                                    "material_data_decentralization_MDM",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.toMDM },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "material.material_data_decentralization_MDM"
                                    )
                                  )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value:
                        (_vm.material_disable,
                        _vm.material_data_synchronization_MDM),
                      expression:
                        "material_disable,material_data_synchronization_MDM",
                    },
                  ],
                  attrs: {
                    "split-button": "",
                    type: "primary",
                    placement: "bottom",
                  },
                  on: { click: _vm.handleClick },
                },
                [
                  _vm._v(" 禁用 "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_disable,
                                  expression: "material_disable",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.disableData },
                            },
                            [_vm._v("RP禁用")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_data_synchronization_MDM,
                                  expression:
                                    "material_data_synchronization_MDM",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.disabledRpf("disable")
                                },
                              },
                            },
                            [_vm._v("RPF禁用")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_disable,
                                  expression: "material_disable",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.disableFreight },
                            },
                            [_vm._v("直送运费禁用")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value:
                        (_vm.material_list_download_full_volume,
                        _vm.material_historical_version_download),
                      expression:
                        "material_list_download_full_volume,material_historical_version_download",
                    },
                  ],
                  attrs: {
                    "split-button": "",
                    type: "primary",
                    placement: "bottom",
                  },
                  on: { click: _vm.handleClick },
                },
                [
                  _vm._v(" 报表 "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.material_list_download_full_volume,
                                  expression:
                                    "material_list_download_full_volume",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.download },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "material.material_list_download_full_volume"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value:
                                    _vm.material_historical_version_download,
                                  expression:
                                    "material_historical_version_download",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.downloadHis },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "material.material_historical_version_download"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value:
                                    _vm.material_historical_version_download,
                                  expression:
                                    "material_historical_version_download",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.downloadByDc },
                            },
                            [_vm._v(_vm._s(_vm.$t("material.downloadAllNew")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.updateMaterialTemplate,
                      expression: "updateMaterialTemplate",
                    },
                  ],
                  ref: "uploadTemplate",
                  staticStyle: {
                    "margin-right": "10px",
                    "vertical-align": "middle",
                    "line-height": "0",
                  },
                  attrs: {
                    "show-file-list": false,
                    headers: _vm.uploadHeader,
                    action: _vm.templateUploadUrl,
                    "on-success": () =>
                      _vm.$message.success(_vm.$t("common.UploadSucceed")),
                    multiple: "false",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { height: "100%" },
                      attrs: { type: "primary", size: "mini" },
                    },
                    [_vm._v("模板更新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableData",
              attrs: {
                sortable: "",
                "max-height": "435",
                data: _vm.tableData,
                "row-key": "tmMaterialRecordId",
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "left",
                  sortable: "",
                  type: "selection",
                  width: "55",
                  align: "center",
                  "reserve-selection": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  prop: "fiveBitCode",
                  label: "GRI",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  prop: "eightBitCode",
                  label: _vm.$t("material.eightBitCode"),
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                  prop: "eightBitCodeName",
                  label: _vm.$t("material.eightBitCodeName"),
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "a-link",
                            on: {
                              click: function ($event) {
                                return _vm.goAdd(
                                  "detail",
                                  scope.row.tmMaterialRecordId
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.eightBitCodeName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  prop: "dummyCode",
                  label: _vm.$t("material.dummyCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                  prop: "settlementUnitName",
                  label: _vm.$t("material.settlementUnitName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  prop: "plantCodeView",
                  label: "工厂编码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                  prop: "tmPlantName",
                  label: "工厂名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  prop: "statusI18n",
                  label: _vm.$t("material.materialProductStatus"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "categoryLevel1Name",
                  label: "Category1",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "categoryLevel2Name",
                  label: "Category2",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "categoryLevel3Name",
                  label: "Category3",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "conductStatusI18n",
                  label: _vm.$t("material.conductStatus"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "currentReviewer",
                  label: _vm.$t("fpaManage.permanent.logicStatus"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  "show-overflow-tooltip": "",
                  prop: "isSrmIssueI18n",
                  label: _vm.$t("material.isSrmIssue"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  "show-overflow-tooltip": "",
                  prop: "isExFactoryPriceIssueI18n",
                  label: _vm.$t("material.isExFactoryPriceIssue"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  "show-overflow-tooltip": "",
                  prop: "isInboundFreightIssueI18n",
                  label: _vm.$t("material.isInboundFreightIssue"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  "show-overflow-tooltip": "",
                  prop: "isMdmReceiveI18n",
                  label: _vm.$t("material.isMdmReceive"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  "show-overflow-tooltip": "",
                  prop: "isExFactoryPriceReceiveI18n",
                  label: _vm.$t("material.isExFactoryPriceReceive"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                  prop: "isMaterialInboundIssueI18n",
                  label: _vm.$t("material.isMaterialInboundIssue"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  "show-overflow-tooltip": "",
                  prop: "isStraightFreightIssueI18n",
                  label: _vm.$t("material.isStraightFreightIssueI18n"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  "show-overflow-tooltip": "",
                  prop: "isFreightReceivedMdmI18n",
                  label: _vm.$t("material.isFreightReceivedMdmI18n"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  "show-overflow-tooltip": "",
                  prop: "mdmDataReleaseDate",
                  label: _vm.$t("material.mdmDataReleaseDate"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "90",
                  "show-overflow-tooltip": "",
                  prop: "fpaBeginEffectiveDate",
                  label: _vm.$t("material.fpaBeginEffectiveDate"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "issuePriceTakeEffectDate",
                  label: _vm.$t("material.issuePriceTakeEffectDate"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "isReceivePriceTouchI18n",
                  label: _vm.$t("material.isReceivePriceTouchI18n"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("material.lssueLog"),
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "a-link",
                            on: {
                              click: function ($event) {
                                return _vm.getLogPage(scope.row.tmMaterialId)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("material.see")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.infoForm"),
            visible: _vm.showDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "infoForm",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.rules,
                "label-position": _vm.labelPosition,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("material.issuePriceTakeEffectDate"),
                            prop: "issuePriceTakeEffectDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                            },
                            model: {
                              value: _vm.infoForm.issuePriceTakeEffectDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.infoForm,
                                  "issuePriceTakeEffectDate",
                                  $$v
                                )
                              },
                              expression: "infoForm.issuePriceTakeEffectDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.confirmToMDM },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.FPARueryPop"),
            visible: _vm.FPADialog,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.FPADialog = $event
            },
          },
        },
        [
          _vm.FPADialogReset
            ? _c("FPADialog", {
                ref: "FPADialogRef",
                attrs: {
                  fpaStatus: _vm.fpaStatus,
                  multipleSelectionFlag: true,
                  eightBitCodeList: _vm.eightBitCodeList,
                  tmMaterialRecordId: _vm.tmMaterialRecordId,
                },
                on: { subCallMethod: _vm.selectFPAMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.PricDistributionLog"),
            visible: _vm.PricDistributionDialog,
            width: "95%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.PricDistributionDialog = $event
            },
          },
        },
        [
          _vm.PricDistributionDialogReset
            ? _c("LogPageDialog", { attrs: { tmMaterialId: _vm.tmMaterialId } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.ThreeButtonsDialog, width: "70%" },
          on: {
            "update:visible": function ($event) {
              _vm.ThreeButtonsDialog = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.sendPriceTouch("Last Month")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("material.IssuedLastMonth")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.sendPriceTouch("This Month")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("material.IssuedMonth")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.sendPriceTouch("Next Month")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("material.IssuedNextMonth")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogTableVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _vm.dialogTableVisible
            ? _c("dialog-table", { attrs: { gridData: _vm.gridData } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            visible: _vm.dialogModifyVisible,
            title: "批量修改",
            width: "25%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogModifyVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _vm.dialogModifyVisible
            ? _c("dialog-modify", {
                attrs: { materialRecordIdList: _vm.materialRecordIdList },
                on: { closeDialog: _vm.closeDialog },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogWithdrawVisible,
            title: "撤回意见",
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogWithdrawVisible = $event
            },
            close: _vm.closeWithDraw,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, rules: _vm.formDataRules },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20, offset: 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          staticStyle: { width: "100%" },
                          attrs: { prop: "approvalDescription" },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.formData.approvalDescription,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "approvalDescription",
                                  $$v
                                )
                              },
                              expression: "formData.approvalDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }